export default "__VITE_ASSET__jeukkdFD__"